import { useQuery } from "@tanstack/react-query";
import { useServices } from "@/services/ServiceProvider";
import { useAuthStore } from "@/stores/useAuthStore";
import { getChainConfig } from "@/config/contracts";
import type { AttentionItem } from "@/features/attention/types";

/** Polls like useNotifications: Realtime is off under Privy. */
export const ATTENTION_POLL_MS = 60_000;

// One empty list, so callers memoizing on `items` don't recompute every render.
const NONE: AttentionItem[] = [];

export function useAttentionItems() {
  const { attention } = useServices();
  const userId = useAuthStore((s) => s.session?.userId);
  const chainId = getChainConfig().chainId;
  const q = useQuery({
    queryKey: ["attention", "mine", chainId, userId],
    queryFn: () => attention.listMine(chainId),
    enabled: !!userId,
    refetchInterval: ATTENTION_POLL_MS,
  });
  return {
    items: q.data ?? NONE,
    // isLoading (not isPending): a disabled/signed-out query stays isPending
    // forever in React Query v5, which would show an endless skeleton.
    isPending: q.isLoading,
    // Only when there is nothing to show: a failed background poll keeps the
    // last good list on screen instead of swapping it for the retry block.
    isError: q.isError && q.data === undefined,
    refetch: () => void q.refetch(),
  };
}
